import { Button } from '@mantine/core';
import { IconThumbUp } from '@tabler/icons-react';

import { useLikeProject } from 'src/Hooks/Mutations/useLikeProject';
import { useUnlikeProject } from 'src/Hooks/Mutations/useUnlikeProject';
import { ProjectDto } from 'src/Services/API/generated';

import styles from './LikeButton.module.scss';

interface Props {
  project: ProjectDto;
}

export const LikeButton = ({ project }: Props) => {
  const { mutate: likeProject, isLoading: loadingLike } = useLikeProject();
  const { mutate: unlikeProject, isLoading: loadingUnlike } = useUnlikeProject();

  const loading = loadingLike ?? loadingUnlike;

  const likesSummary = project.likesSummary ?? { count: 0, didILike: false };

  const toggleLike = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (loading) return;

    if (likesSummary.didILike) {
      unlikeProject(project.id);
    } else {
      likeProject(project.id);
    }
  };

  return (
    <Button
      onMouseDown={e => e.stopPropagation()}
      onClick={toggleLike}
      className={[styles.likeButton, likesSummary.didILike ? styles.isAlreadyLiked : ''].join(' ')}
      leftSection={<IconThumbUp size={16} />}
      loading={loading}
      variant={likesSummary.didILike ? 'light' : 'subtle'}
      size="xs"
      color={likesSummary.didILike ? 'blue' : 'gray'}
    >
      {likesSummary.count}
    </Button>
  );
};
